import { useState } from 'react';
import { Info, X } from 'shared/icons';

const STORAGE_PREFIX = 'layout:desktop-only-notice';

/**
 * Aviso compacto e dispensável exibido APENAS no mobile (lg:hidden) para telas
 * densas — workbenches multi-painel otimizados para desktop (ex.: /operacoes).
 * Não bloqueia a navegação, só sinaliza. Flutua logo acima da barra inferior
 * (MobileSidebar, h-16) e a dispensa é lembrada por sessão e por rota.
 *
 * Uso: o Layout renderiza `<DesktopOnlyNotice routeKey="/operacoes" />` quando a
 * rota atual está em DESKTOP_OPTIMIZED_PATHS (com `key={routeKey}` pra remontar
 * ao trocar de rota densa).
 */
const DesktopOnlyNotice = ({ routeKey = 'global' }) => {
    const storageKey = `${STORAGE_PREFIX}:${routeKey}`;
    const [isDismissed, setDismissed] = useState(() => {
        try {
            return sessionStorage.getItem(storageKey) === '1';
        } catch {
            return false;
        }
    });

    if (isDismissed) {
        return null;
    }

    const handleDismiss = () => {
        setDismissed(true);
        try {
            sessionStorage.setItem(storageKey, '1');
        } catch {
            // Ignora sessionStorage indisponível em contextos restritos.
        }
    };

    return (
        <div
            role="status"
            className="lg:hidden fixed inset-x-3 bottom-[4.5rem] z-30 flex items-center gap-2 rounded-lg border border-mono-200 dark:border-mono-800 bg-white/95 dark:bg-mono-950/95 px-3 py-2 shadow-lg backdrop-blur"
        >
            <Info size={18} className="shrink-0 text-mono-500" />
            <p className="flex-1 text-xs text-mono-600 dark:text-mono-400">Esta tela é otimizada para desktop.</p>
            <button
                type="button"
                onClick={handleDismiss}
                aria-label="Dispensar aviso"
                className="shrink-0 rounded p-1 text-mono-500 hover:bg-mono-100 dark:hover:bg-mono-900 hover:text-black dark:hover:text-white transition-colors"
            >
                <X size={16} />
            </button>
        </div>
    );
};

export default DesktopOnlyNotice;
